"use strict";

module.exports = {
  'name': 'squeeze',
  'category': 'Matrix',
  'syntax': ['squeeze(x)'],
  'description': 'Remove inner and outer singleton dimensions from a matrix.',
  'examples': ['a = zeros(3,2,1)', 'size(squeeze(a))', 'b = zeros(1,1,3)', 'size(squeeze(b))'],
  'seealso': ['concat', 'det', 'diag', 'identity', 'inv', 'ones', 'range', 'size', 'subset', 'trace', 'transpose', 'zeros']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/matrix/squeeze.js
// module id = 906
// module chunks = 0